import { HistoryLog } from '@/interfaces/historyLog';
import { HistoryLogResource, historyLogResource } from '@/resources/history.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł historii
 *
 * @export
 * @class HistoryLogModule
 * @extends {EntityModule<HistoryLog, HistoryLogResource>}
 */
export class HistoryLogModule extends EntityModule<HistoryLog, HistoryLogResource> {
  constructor() {
    super(historyLogResource);
  }
}

export default new HistoryLogModule();
